import script from "./ProductActive.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductActive.vue?vue&type=script&setup=true&lang=ts"

import "./ProductActive.vue?vue&type=style&index=0&id=047fe4fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-047fe4fe"]])

export default __exports__